// percent of the full width of the screen
export const MIN_DRAWER_SIZE_PX = 150;

// percent of the full width of the screen
export const MAX_DRAWER_SIZE_IN_PERCENT = 55;

// amount of shift in the file directory
export const FILE_DIRECTORY_AMOUNT_OF_SHIFT = 8;

// height of the searched file card
export const SEARCHED_FILE_CARD_HIGHT = 28;

export const SIDE_DRAWER_WIDTH_INITIAL=208;